// extracted by mini-css-extract-plugin
export default {"root":"gFaRZhRH8f","root_isBorderless":"KoyxdjcjbT","root_active":"g8j2Ad9qKO","root_initialSizeLarge":"ywpoh6YaCs"};